export function dateFromTicks(ticks) {
  const ticksAtUnixEpoch = 621355968000000000n;
  const ticksBig = BigInt(ticks);

  // Convert ticks → milliseconds
  const ms = Number((ticksBig - ticksAtUnixEpoch) / 10000n);

  return new Date(ms);
}

export function formatTimestamp(timestamp) {
  if (!timestamp) return 'N/A';
  
  const date = dateFromTicks(timestamp);
  if (isNaN(date.getTime())) return 'Invalid Date';
  
  return date.toLocaleString();
}

